import { render, staticRenderFns } from "./IClassroomPicker.vue?vue&type=template&id=32f528cf&"
import script from "./IClassroomPicker.vue?vue&type=script&lang=js&"
export * from "./IClassroomPicker.vue?vue&type=script&lang=js&"
import style0 from "./IClassroomPicker.vue?vue&type=style&index=0&id=32f528cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports